import React, { useState } from 'react';
import PropTypes from 'prop-types';

const Tooltip = ({
  children,
  text,
  direction,
  hover,
  control,
  specialClass,
}) => {
  const [show, setShow] = useState(true);
  return (
    <div
      className="tooltip-box"
      onMouseEnter={() => {
        if (hover) setShow(true);
      }}
      onMouseLeave={() => {
        if (hover) setShow(false);
      }}
    >
      {children}
      {(show || control) && (
        <div className={`tooltip ${direction} ${specialClass}`}>
          <p className="tooltip__text">
            {text}
          </p>
        </div>
      )}
    </div>
  );
};

Tooltip.defaultProps = {
  direction: 'right',
  hover: true,
  control: false,
  specialClass: '',
};

Tooltip.propTypes = {
  children: PropTypes.node.isRequired,
  text: PropTypes.string.isRequired,
  direction: PropTypes.oneOf(['top', 'bottom', 'right', 'left']),
  hover: PropTypes.bool,
  control: PropTypes.bool,
  specialClass: PropTypes.string,
};

export default Tooltip;
